import { NgModule } from '@angular/core';
import { InternationalPhoneComponent } from './international-phone.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';


@NgModule({
  declarations: [],
  imports: [ReactiveFormsModule], // , NgxIntlTelInputModule],
  exports: []
})
export class InternasionalPhoneModule { }
